<script setup lang="ts">
    import { ref } from 'vue'
    const show = ref(false)
    defineProps<{
        question: string;
        answer: string;
    }>();
</script>

<template>
   <div class="pb-4" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <button
        @click="show = !show"
        class="flex items-center justify-between w-full pt-4 pr-1 font-semibold text-xl text-left text-gray-700 outline-none hover:text-primary focus:text-primary focus:outline-none"
      >
       <span itemprop="name">{{question}}</span>
        <svg
          :class="{ 'rotate-45': show }"
          class="flex-none w-6 h-6 ml-4 transition transform duration-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#00000033"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
      <div :class="{ 'mb-4 mt-4 h-auto' : show,  'h-0 pointer-events-none delay-250' : !show }" x-cloak 
        class="transition-all transform duration-500 text-black/70 text-lg overflow-clip"
        itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer"
        >
        <p itemprop="text" class="transition-opacity transform duration-500" :class="{'opacity-0': !show, 'delay-250 opacity-100': show}"  v-html="answer"></p>
      </div>
    </div>

</template>

